import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, InputAdornment, InputBase, Paper, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CancelIcon from '@mui/icons-material/Cancel';
import { getTarea, postComentarioTarea, postComentarioTareaInter } from '../../../services/apis';
import { useNavigate, useParams } from 'react-router-dom';
import TextsmsIcon from '@mui/icons-material/Textsms';
import SendIcon from '@mui/icons-material/Send';
import logoempresa from '../../../media/logoempresa.png';


export const TareaDialog = ({ open, setOpen, tareaInfo, handleEvent, backgroundCard, textColor }) => {

    const navigate = useNavigate();

    const handleClose = () => {
        setOpen(false);
    };
    const [tarea, setTarea] = useState(tareaInfo);

    //aux
    const mensajePorDefecto = [{
        autor: "3",
        color: "7303fc",
        comentario: "Escribe un Comentario",
    }];
    //utils
    const [comentarios, setComentarios] = useState([]);
    const [comentariosInternos, setComentariosInternos] = useState([]);
    const [mensaje, setMensaje] = useState('');
    const [mensajeInterno, setMensajeInterno] = useState('');

    const [opciones, setOpciones] = useState([]);


    const param = useParams();

    const handleInputChange = (event) => {
        setMensaje(event.target.value);
    };
    const handleInputChangeInterno = (event) => {
        setMensajeInterno(event.target.value);
    };

    const handleKeyPress = (event) => {
        console.log(event.target.name);

        if (event.target.name === 'mensaje') {
            if (event.key === 'Enter') {
                event.preventDefault();
                enviarComentario();
            }
        } else {
            if (event.key === 'Enter') {
                event.preventDefault();
                enviarComentarioInterno();
            }
        }
    };


    const cargarTareas = async () => {
        try {
            const response = await getTarea(param.id, tarea.id, 2);
            setComentarios(response.data.comentarios.length > 0 ? response.data.comentarios : mensajePorDefecto);
            setComentariosInternos(response.data.comentarios_internos.length > 0 ? response.data.comentarios_internos : mensajePorDefecto);

            // setOpciones(response.data.opcionesTareas);
        } catch (error) {
            console.error("Error al añadir el cliente:", error);
        }
    }

    const enviarComentario = async () => {

        if (mensaje != '') {
            let temp = [...comentarios];
            let nuevoComentario = {
                autor: "1",
                color: '#FFFFFFF',
                comentario: mensaje,
                fecha: "2024-06-10",
                nombre: localStorage.username,
                id_tarea: tarea.id,
                id_proyecto: tarea.id_proyecto
            }
            try {
                const response = await postComentarioTarea(nuevoComentario);


            } catch (error) {
                console.error("Error al añadir el cliente:", error);
            }

            temp.push(nuevoComentario);
            setMensaje('')
            cargarTareas()
        }

    }

    const enviarComentarioInterno = async () => {

        if (mensajeInterno != '') {
            let temp = [...comentarios];
            let nuevoComentario = {
                autor: "1",
                color: '#FFFFFFF',
                comentario: mensajeInterno,
                fecha: "2024-06-10",
                nombre: localStorage.username,
                id_tarea: tarea.id,
                id_proyecto: tarea.id_proyecto
            }
            try {
                const response = await postComentarioTareaInter(nuevoComentario);


            } catch (error) {
                console.error("Error al añadir el cliente:", error);
            }

            temp.push(nuevoComentario);
            setMensajeInterno('')
            cargarTareas()
        }

    }

    useEffect(() => {
        if (open === true) {
            cargarTareas();
        }
    }, [open])



    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth='xl'
        >

            <DialogContent style={{
                backgroundColor: "#" + backgroundCard,
                color: textColor,
                minWidth: '90%'
            }}>
                <Grid
                    container
                    direction="column"
                    justifyContent="start"
                    alignItems="start"
                    xs={12}
                    sx={{ mb: 3 }}
                >
                    <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        xs={12}
                        sx={{ mb: 3 }}
                    >
                        <Grid
                            container
                            xs={8}
                            justifyContent="start"
                            alignItems="start"
                            sx={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                WebkitLineClamp: 2, // Limita el número de líneas
                                WebkitBoxOrient: 'vertical',
                                minHeight: '4vh', // Ajusta este valor a la altura fija que deseas
                                maxHeight: '10vh',
                            }}
                        >
                            <Typography variant='h4'>
                                {tarea.asunto}
                            </Typography>
                        </Grid>


                        <CancelIcon variant='contained' className='pointer' onClick={handleClose}></CancelIcon>
                    </Grid>

                    <Typography variant='subtitle1'>
                        <strong> Cliente: </strong> {tarea.cliente}
                    </Typography>

                    <Typography variant="subtitle1">
                        <strong>Correo: </strong>{tareaInfo.correo}
                    </Typography>

                    <Typography variant='h5'>
                        <strong> Descripción:</strong> {tarea.descripcion}
                    </Typography>

                    <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        xs={12}
                        sx={{ mt: 2 }}
                    >
                        <Grid item xs={12} style={{ textAlign: 'left' }}>
                            <Typography variant="subtitle1">
                                <strong> Horas empleadas: </strong>
                                {`${Math.floor(tareaInfo.minutos / 60)}h ${tareaInfo.minutos % 60}m`}
                            </Typography>
                        </Grid>
                        <Grid
                            container
                            direction="row"
                            justifyContent="start"
                            alignItems="start"
                            xs={12} md={5.5}
                        >
                            {tareaInfo.trabajadores.length > 0 && (
                                <Grid container xs={12} direction="row" justifyContent="start" alignItems="start">
                                    <Grid container xs={12} direction="row" justifyContent="start" alignItems="start" >
                                        <Typography variant="subtitle1" gutterBottom>
                                            <strong> Asignado a:&nbsp;</strong>
                                            {(tareaInfo.trabajadores.slice(0, 3)).map((trabajador, index) => (
                                                <span>{trabajador.label}&nbsp;</span>
                                                // <Grid item xs={12} textAlign={'left'}>
                                                //     <Typography variant="caption" gutterBottom key={index} sx={{ fontWeight: 600 }}>
                                                //         {trabajador.label}&nbsp;
                                                //     </Typography>
                                                // </Grid>
                                            ))}
                                        </Typography>
                                    </Grid>


                                    <>
                                        {tareaInfo.trabajadores.length > 3 && (
                                            <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 600 }}>
                                                y mas...
                                            </Typography>
                                        )}
                                    </>
                                </Grid>
                            )}
                            {tareaInfo.trabajadores.length == 0 && (
                                <Grid container xs={12} justifyContent="start" alignItems="center">
                                    <Typography variant="subtitle1" gutterBottom>
                                        <strong>Asignado a: </strong>Sin Asignar
                                    </Typography>
                                </Grid>
                            )}


                        </Grid>


                        <Grid
                            container
                            direction="row"
                            justifyContent="end"
                            alignItems="start"
                            xs={12} md={5.5}
                        // style={{
                        // minHeight: '15vh',
                        // maxHeight: '35vh',
                        // }}
                        >
                            {tareaInfo.usuarios_con_tiempo.length > 0 && (
                                <Grid container xs={12} justifyContent="end" alignItems="start">
                                    <Typography variant="subtitle1" gutterBottom style={{ marginBottom: '-0.2em' }} >
                                        <strong>En curso por:&nbsp;</strong>
                                        {(tareaInfo.usuarios_con_tiempo.slice(0, 3)).map((trabajador, index) => (
                                            <span>{trabajador.label}&nbsp;</span>
                                        ))}
                                    </Typography>

                                    <>
                                        {tareaInfo.usuarios_con_tiempo.length > 3 && (
                                            <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 600 }}>
                                                y mas...
                                            </Typography>
                                        )}
                                    </>
                                </Grid>
                            )}
                            {tareaInfo.usuarios_con_tiempo.length == 0 && (
                                <Grid container xs={12} justifyContent="end" alignItems="end" >
                                    <Typography variant="subtitle1" gutterBottom textAlign={'right'}>
                                        <strong>En curso por: </strong>Sin Trabajadores En Curso
                                    </Typography>
                                    <Typography variant="subtitle1" gutterBottom textAlign={'right'}>

                                    </Typography>
                                </Grid>
                            )}

                        </Grid>
                    </Grid>

                </Grid>

                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="end"
                    xs={12}
                >
                    <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        xs={12} lg={5.5}
                    >
                        {comentarios.length > 0 && (
                            <>
                                <div className='envase-chat'>
                                    <strong>&nbsp;Comentarios:</strong>
                                    <div className='contenedor-chat' style={{ minHeight: '21.7vh' }}>
                                        {comentarios.map((comentario => (
                                            <div
                                                className={`bocadillo-chat ${comentario.autor == 1 ? 'autor' : ''}`}
                                                key={comentario.id}
                                            >                                        <div style={{ color: comentario.color }}>
                                                    <strong>{comentario.nombre}</strong>
                                                </div>
                                                <div>
                                                    {comentario.comentario}
                                                </div>
                                                <div className='comentario-fecha'>
                                                    {comentario.fecha}
                                                </div>
                                            </div>
                                        )))}

                                    </div>
                                    <Grid xs={12} className='chat-bar'>
                                        <Paper
                                            component="form"
                                            sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: '100%', backgroundColor: '#e1e0e0' }}
                                            variant='outlined'
                                            onSubmit={(e) => { e.preventDefault(); enviarComentario(); }}
                                        >
                                            <InputBase
                                                sx={{ ml: 1, flex: 1 }}
                                                placeholder="Escribe un mensaje nuevo"
                                                inputProps={{ 'aria-label': 'Escribe un mensaje nuevo' }}
                                                value={mensaje}
                                                name='mensaje'
                                                onChange={handleInputChange}
                                                onKeyPress={handleKeyPress}
                                            />
                                            <IconButton type="button" sx={{ p: '10px' }} aria-label="send" >
                                                <SendIcon onClick={() => enviarComentario()} />
                                            </IconButton>
                                        </Paper>
                                    </Grid>
                                </div>
                            </>
                        )}
                    </Grid>

                    <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        xs={12} lg={5.5}
                    >
                        {/* // comentarios internos */}
                        {comentariosInternos.length > 0 && (
                            <>
                                <div className='envase-chat-interno'>
                                    <Grid container xs={12} direction={'row'} justifyContent={'space-between'} >
                                        <strong>&nbsp;Comentarios Internos:</strong>
                                        <img src={logoempresa} alt="Logo" className="logo-chat" onClick={() => navigate('/')} />
                                    </Grid>

                                    <div className='contenedor-chat' style={{ minHeight: '18vh' }}>
                                        {comentariosInternos.map((comentario => (
                                            <div
                                                className={`bocadillo-chat ${comentario.autor == 1 ? 'autor' : ''}`}
                                                key={comentario.id}
                                            >                                        <div style={{ color: comentario.color }}>
                                                    <strong>{comentario.nombre}</strong>
                                                </div>
                                                <div>
                                                    {comentario.comentario}
                                                </div>
                                                <div className='comentario-fecha'>
                                                    {comentario.fecha}
                                                </div>
                                            </div>
                                        )))}

                                    </div>
                                    <Grid xs={12} className='chat-bar'>
                                        <Paper
                                            component="form"
                                            sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: '100%', backgroundColor: '#e1e0e0' }}
                                            variant='outlined'
                                            onSubmit={(e) => { e.preventDefault(); enviarComentario(); }}
                                        >
                                            <InputBase
                                                sx={{ ml: 1, flex: 1 }}
                                                placeholder="Escribe un mensaje nuevo"
                                                inputProps={{ 'aria-label': 'Escribe un mensaje nuevo' }}
                                                name='mensajeInterno'
                                                value={mensajeInterno}
                                                onChange={handleInputChangeInterno}
                                                onKeyPress={handleKeyPress}
                                            />
                                            <IconButton type="button" sx={{ p: '10px' }} aria-label="send" >
                                                <SendIcon onClick={() => enviarComentarioInterno()} />
                                            </IconButton>
                                        </Paper>
                                    </Grid>
                                </div>

                            </>
                        )}
                    </Grid>
                    <Grid
                        container
                        direction="row"
                        justifyContent="end"
                        alignItems="center"
                        xs={12}
                    >
                        <Typography variant='inherit'>
                            <strong>Creado por: </strong>{tareaInfo.creador}
                        </Typography>
                    </Grid>

                </Grid>






            </DialogContent>
            {/* <DialogActions style={{
                backgroundColor: "#" + backgroundCard,
                color: textColor
            }}>
                {opciones.map((opcion, index) => (
                    <Grid container xs={3} sm={3} md={3} xl={3} gap={1} justifyContent="space-around" alignItems="center">
                        <Button
                            variant='contained'
                            className='button-default'
                            key={index}
                            onClick={() => handleEvent(opcion.id_estado)}
                            disabled={
                                opcion.id_estado == 4 ? tarea.id_estado != 3 :
                                tarea.id_estado == 3 && opcion.id_estado != 4
                                        ? true
                                        : (tarea.id_estado == 1)
                                            ? (opcion.id_estado == 1)
                                            : (opcion.id_estado == 2)}
                        >
                            {opcion.nombre}
                        </Button>
                    </Grid>

                ))}
            </DialogActions> */}
        </Dialog>
    )
}
